import { useMemo } from "react";

export const ResumenGestion = ({ clientes, resultados }) => {
	const stats = useMemo(() => {
		const conteo = {};

		clientes.forEach((c) => {
			const key = c.idResultadoGestion === null || c.idResultadoGestion === undefined
				? "null"
				: String(c.idResultadoGestion);
			conteo[key] = (conteo[key] || 0) + 1;
		});

		const tarjetas = [
			{
				id: "null",
				label: "No gestionado",
				count: conteo["null"] || 0,
				isNull: true,
			},
		];

		resultados.forEach((r) => {
			tarjetas.push({
				id: String(r.idResultadoGestion),
				label: r.Descripcion,
				count: conteo[String(r.idResultadoGestion)] || 0,
				isVendido: r.idResultadoGestion === 4 || r.idResultadoGestion === 6,
				isNull: false,
			});
		});

		return tarjetas;
	}, [clientes, resultados]);

	const total = clientes.length;

	const getCardStyle = (item) => {
		if (item.isNull)
			return {
				border: "1px solid rgba(156,163,175,0.25)",
				accent: "#9ca3af",
				bg: "rgba(156,163,175,0.07)",
				pill: "bg-gray-600/40 text-gray-400",
			};
		if (item.isVendido)
			return {
				border: "1px solid rgba(52,211,153,0.3)",
				accent: "#34d399",
				bg: "rgba(52,211,153,0.07)",
				pill: "bg-emerald-500/20 text-emerald-300",
			};
		return {
			border: "1px solid rgba(99,102,241,0.25)",
			accent: "#818cf8",
			bg: "rgba(99,102,241,0.06)",
			pill: "bg-indigo-500/20 text-indigo-300",
		};
	};

	return (
		<div className="max-w-[1400px] mx-auto mb-6">
			{/* Header row */}
			<div className="flex items-center justify-between mb-3">
				<p className="text-xs font-bold uppercase tracking-widest text-indigo-400">
					Resumen de gestión
				</p>
				<span className="text-xs text-indigo-500">
					{total} solicitud{total !== 1 ? "es" : ""} en total
				</span>
			</div>

			{/* Cards */}
			<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
				{stats.map((item) => {
					const style = getCardStyle(item);
					const pct = total > 0 ? Math.round((item.count / total) * 100) : 0;

					return (
						<div
							key={item.id}
							className="rounded-xl px-4 py-3 flex flex-col gap-2 transition-transform hover:scale-105"
							style={{
								background: style.bg,
								border: style.border,
							}}
						>
							{/* contador */}
							<span
								className="text-2xl font-bold leading-none"
								style={{ color: style.accent }}
							>
								{item.count}
							</span>

							{/* Label */}
							<p className="text-white/80 text-xs font-medium leading-tight line-clamp-2 min-h-[2rem]">
								{item.label}
							</p>

							{/* barra progreso */}
							<div className="flex items-center gap-2 mt-auto">
								<div className="flex-1 h-1 rounded-full bg-white/10 overflow-hidden">
									<div
										className="h-full rounded-full transition-all duration-500"
										style={{
											width: `${pct}%`,
											background: style.accent,
										}}
									/>
								</div>
								<span className="text-[10px] font-semibold" style={{ color: style.accent }}>
									{pct}%
								</span>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};